export const blitzTypes = ['BLITZ-1', 'BLITZ-2', 'BLITZ-3'];
